import React, { useContext, useEffect, useState } from "react";
// Formik Validation
import "../../assets/scss/custom/pages/_signup.scss";
import ToastDialog from "components/Common/ToastDialog";
import API_SERVICES from "constants/app.constants";
import CryptoJS from "crypto-js";
import { useFormik } from "formik";
import { resetPassword } from "http/auth/reset";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { LoadCanvasTemplateNoReload, loadCaptchaEnginge, validateCaptcha } from 'react-simple-captcha';

import {
  Button,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Popover,
  PopoverBody,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import * as Yup from "yup";
import { SystemConfigurationContext } from "context/systemConfigContext";
import { Tooltip } from 'react-tooltip';

const ResetPassword = () => {
  const navigate = useNavigate();
  const [popovertop, setpopovertop] = useState(false);
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [isInvalid, setIsInvalid] = useState(false);
  const [captchaInput, setCaptchaInput] = useState("")
  const [visible, setVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  document.title = "Reset Password | DMS";
  const { inputMax } = useContext(SystemConfigurationContext)

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tk = queryParams.get("tk");

  //form validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      password: "",
      confirm_password: "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .min(6, "At least 6 characters long")
        .max(16, "Must be 16 characters or less")
        .matches(API_SERVICES.PASSWORD_PATTERN,
          "Password must inlcude at least one lowercase letter, one uppercase letter, one number, and one special character"
        )
        .required("Password is required"),
      confirm_password: Yup.string().when("password", {
        is: (val) => (!!(val && val.length > 0)),
        then: Yup.string().oneOf(
          [Yup.ref("password")],
          "Password do not match"
        ),
      }),
    }),
    onSubmit: (values) => {
      const isCaptchaSolved = handleValidateCaptcha()
      if (!isCaptchaSolved.status) {
        setIsLoading(false)
        setToastInfo({ message: isCaptchaSolved.message, showToast: true, role: "error" })
        return
      }
      submitUserLogin(values);
    },
  });

  const handleValidateCaptcha = () => {
    if (!captchaInput) return { status: false, message: "Please enter captcha" }
    const captcha = validateCaptcha(captchaInput, false)
    if (!captcha) return { status: false, message: "Please enter valid captcha" }
    return { status: true }
  }

  const submitUserLogin = (values) => {
    const passphrase = process.env.REACT_APP_KEY;
    const encrypted = CryptoJS.AES.encrypt(
      values.password,
      passphrase
    ).toString();
    const encryptedRe = CryptoJS.AES.encrypt(
      values.confirm_password,
      passphrase
    ).toString();
    const postParams = {
      password: encrypted,
      confirm_password: encryptedRe,
      token: tk,
    };
    setIsLoading(true);
    resetPassword(postParams)
      .then((response) => {
        if (response.status) {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "success" });
          setTimeout(() => {
            navigate("/login");
          }, 1000);
        } else {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "error" });
          setIsInvalid(true);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        setIsLoading(false);
      })
      .finally((f) => {
        setIsLoading(false);
      });
  };



  const handleCaptchaReload = () => {
    loadCaptchaEnginge(6);
  }

  useEffect(() => {
    handleCaptchaReload()
  }, [])

  return (
    <React.Fragment>
      <div className="account-pages bg-auth account-pages-bg ">
        <Row className="justify-content-center w-100 h-100vh">
          <Col xl={8} className="d-none d-lg-block">
            <div className="left-section h-100">
              <div className="d-flex justify-content-center w-100 h-100 align-items-center">
                <img
                  className="img-fluid verification-img"
                  src={"/login5.svg"}
                  alt="Logo"
                />
              </div>
            </div>
          </Col>
          <Col
            md={11}
            lg={11}
            xl={4}
            className="form-layout-section  content-center"
            style={{ height: "560px", marginTop: "6%" }}
          >
            <div className="p-2">
              <div className="d-flex w-60 m-auto justify-content-center d-block">
                <img
                  src={"/subros_logo.png"}
                  alt=""
                  className="img-fluid ci-logo"
                />
              </div>
              <div className="d-flex flex-column align-items-left">
                <h3 className="mt-3 mb-3 header-reg" style={{ textAlign: 'center', color: "#344fa0", }}>Reset Password</h3>
              </div>

              <Form
                className="needs-validation"
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <div className="form-floating mb-3">
                  <div className="password-info">
                    <div className="form-floating">
                      <Input
                        maxLength={inputMax}
                        name="password"
                        placeholder="Enter Valid Password"
                        type={visible ? "text" : "password"}
                        className="form-control"
                        id="validationCustom04"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.password || ""}
                        style={{
                          backgroundImage: "none",
                        }}
                        invalid={
                          !!(
                            validation.touched.password &&
                            validation.errors.password
                          )
                        }
                        disabled={isLoading}
                      />

                      <Label htmlFor="validationCustom04">Password</Label>
                      {validation.touched.password &&
                        validation.errors.password ? (
                        <FormFeedback type="invalid">
                          {validation.errors.password ===
                            "Enter valid password pattern" ? (
                            <div style={{ marginLeft: "1rem" }}>
                              {validation.errors.password}
                            </div>
                          ) : (
                            validation.errors.password
                          )}
                        </FormFeedback>
                      ) : null}
                    </div>
                    {validation.touched.password &&
                      validation.errors.password ===
                      "Enter valid password pattern" ? (
                      <div
                        className="password-j"
                        id="passwordInfo"
                        onMouseOver={() => {
                          setpopovertop(!popovertop);
                        }}
                        onMouseOut={() => {
                          setpopovertop(!popovertop);
                        }}
                      >
                        <i
                          style={{ color: "#f46a6a" }}
                          className="mdi mdi-information-outline"
                        ></i>
                      </div>
                    ) : (
                      <div id="passwordInfo" />
                    )}

                    <div
                      onClick={() => setVisible(!visible)}
                      className="password-i"
                      id="passwordInfo"
                    >
                      {visible ? (
                        <i className="mdi mdi-eye"></i>
                      ) : (
                        <i className="mdi mdi-eye-off"></i>
                      )}
                    </div>
                  </div>

                  <Popover
                    className="password-dialog"
                    placement="left"
                    trigger="focus"
                    isOpen={popovertop}
                    target="passwordInfo"
                    toggle={() => {
                      setpopovertop(!popovertop);
                    }}
                  >
                    <PopoverBody>
                      <div className="d-flex flex-column">
                        <span className="title">Requirements</span>
                        <ul className="mt-2">
                          <li>Min. 8 Char. length</li>
                          <li>Min 1 lower-case</li>
                          <li>Min 1 upper-case</li>
                          <li>Min 1 special char(!,@,#,etc.)</li>
                          <li>Letter and numbers</li>
                        </ul>
                      </div>
                    </PopoverBody>
                  </Popover>
                </div>

                <div className="form-floating mb-3">
                  <Input
                    maxLength={inputMax}
                    name="confirm_password"
                    type="password"
                    placeholder="Password"
                    id="validationPassword"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.confirm_password || ""}
                    invalid={
                      !!(validation.touched.confirm_password &&
                        validation.errors.confirm_password)
                    }
                    disabled={isLoading}
                  />
                  <Label htmlFor="validationPassword">Confirm Password</Label>
                  {validation.touched.confirm_password &&
                    validation.errors.confirm_password ? (
                    <FormFeedback type="invalid">
                      {validation.errors.confirm_password}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3 p-0 d-flex align-items-center justify-content-start d-inline-block captcha">
                  <LoadCanvasTemplateNoReload />
                  <button
                    type="button"
                    className="btn-theme-transparent btn "
                    id="reloadCaptcha"
                    onClick={() => handleCaptchaReload()}
                    data-tooltip-id={`refresh-button`}
                  >
                    <i className="mdi mdi-refresh"></i>
                  </button>
                  <UncontrolledTooltip
                    placement="bottom"
                    target="reloadCaptcha"
                    trigger="hover"
                  >Click to refresh captcha</UncontrolledTooltip>
                </div>
                <div className="form-floating mb-3">
                  <Input

                    name="captcha"
                    id="validationCustom04"
                    className="form-control"
                    placeholder="Enter Captcha"
                    type="text"
                    value={captchaInput}
                    onChange={(e) => setCaptchaInput(e.target.value)}
                  />
                  <Label htmlFor="validationCustom04">
                    Enter Captcha
                  </Label>
                </div>

                <div className="w-100 mt-3 d-flex justify-content-center mb-3">
                  <Button style={{background:"#344fa0"}} type="submit">
                    {isLoading && (
                      <span
                        className="spinner-border spinner-border-sm ms-2 me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    )}
                    {!isLoading && <span>Reset Password</span>}
                    {isLoading && <span>Authenticating</span>}
                  </Button>
                </div>
              </Form>
              {isInvalid && (
                <div className="mt-2 text-center">
                  <p>
                    You already reset password ?{" "}
                    <Link
                      to="/login"
                      className="fw-medium text-primary"
                    >
                      {" "}
                      Login
                    </Link>{" "}
                  </p>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </div>

      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </React.Fragment>
  );
};

export default ResetPassword;

